import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFolder3DCubeSizeS from './IconFolder3DCube_size_s';

const props: CreateIconArguments = {
  l: IconFolder3DCubeSizeS,
  m: IconFolder3DCubeSizeS,
  s: IconFolder3DCubeSizeS,
  xs: IconFolder3DCubeSizeS,
  name: 'IconFolder3DCube',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
